import React from "react";
import cx from "classnames";
import { Container } from "src/components/container";
import { BlockContent } from "src/components/block-content";

import { useInView } from "react-intersection-observer";

import * as styles from "./b-corp-copy.module.css";

export interface SustainabilityBCorpCopyProps {
	headline: any[];
	show: boolean;
}

export const SustainabilityBCorpCopy = ({
	data,
}: {
	data: SustainabilityBCorpCopyProps;
}) => {
	const { headline, show } = data;

	const { ref, inView } = useInView({
		threshold: 0.5,
	});

	return (
		<div className={styles.bCorpCopy} ref={ref}>
			<Container>
				<BlockContent
					className={cx("ac title highlight-em", inView ? "in-view" : "")}
					blocks={headline}
				/>
			</Container>
		</div>
	);
};
